import DetailsReporting from './DetailsReporting'

export default DetailsReporting
